import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@/store/store";
import { getEsiaParams } from "../../../helpers/esia";
import { redirect } from "../../../helpers/redirect";
import { getTinkoffIDParams } from "../../../helpers/tinkoff";
import { redirectToLkThunk } from "../../../server/thunks/thunks";
import {
  selectIsAuth,
  selectIsOperator,
  selectLockOAuthData,
} from "../../../store/selectors";
import { headerLkLinkDisabledRoutes } from "@/helpers/const";

interface UserAccountButtonProps {
  urls: string[];
  children: (props: {
    loading: boolean;
    hidden: boolean;
    onClick: () => Promise<void>;
  }) => React.ReactNode;
}

export const UserAccountButton = ({
  urls,
  children,
}: UserAccountButtonProps) => {
  const location = useLocation();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const lockOAuthData = useAppSelector(selectLockOAuthData);
  const isOperator = useAppSelector(selectIsOperator);
  const isAuth = useAppSelector(selectIsAuth);

  const { esiaInfoId } = getEsiaParams(location);
  const { tinkoffTraceId } = getTinkoffIDParams(location);

  const [loading, setLoading] = useState(false);

  // метод прятать ТОЛЬКО кнопку личного кабинета
  const hidden =
    lockOAuthData ||
    esiaInfoId ||
    tinkoffTraceId ||
    urls.indexOf(location.pathname) === -1 ||
    headerLkLinkDisabledRoutes.includes(location.pathname);

  const getUrlForUserAccount = () => {
    if (isAuth) return null;
    if (location.pathname === "/registration") return "/authorization";
    if (location.pathname === "/authorization") return "/registration";
    return "/authorization";
  };
  const url = getUrlForUserAccount();

  const onClick = async () => {
    if (url) {
      navigate(url, { replace: true });
      return;
    }
    setLoading(true);

    const response = await dispatch(redirectToLkThunk("application/list"));
    if (response?.result) {
      redirect(response.redirectUrl);
    }
  };

  if (isOperator) return null;

  return children({ loading, hidden, onClick });
};
